import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

export interface DepartmentsListAlertProps {
  readonly message: MessageKey;
}

const DepartmentsListAlert = ({ message }: DepartmentsListAlertProps) => {
  const t = useTranslations();

  return (
    <div className="flex justify-center py-24">
      <Typography variant="body-small">{t(message)}</Typography>
    </div>
  );
};

export default DepartmentsListAlert;
